<template>
  <div>
    <p v-if="availableChannelsAlert">
      <b-alert show variant="warning">
        Você não possui nenhuma integração.
        <a href="https://painel.plugg.to/settings">{{ $t("Clique aqui") }}</a>
        para configurar.
      </b-alert>
    </p>
    <br />
    <TabsComponent
      :options_por_conta="options_por_conta"
      :checkFaturador="checkFaturador"
      :usr_orders="usr_orders"
      :availableChannels="availableChannels"
      :apps="apps"
    />
    <back-to-top bottom="50px" right="4%">
      <button
        v-b-tooltip.hover
        title="Voltar para o top"
        type="button"
        class="btn btn-info btn-to-top"
      >
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>

<script>
import ScreensMenu from "./Aggregates/ActionMenu/ScreensMenu.vue";
import TabsComponent from "./Aggregates/Tabs.vue";
import BackToTop from "vue-backtotop";
import axios from "axios";

export default {
  name: "expedition",
  components: { ScreensMenu, TabsComponent, BackToTop },
  data() {
    return {
      apps: [],
      usr_orders: null,
      checkFaturador: false,
      availableChannels: [{ value: null, text: "Selecione um canal..." }],
      availableChannelsAlert: false,
      options_por_conta: [{ value: null, text: "Selecione a conta..." }],
    };
  },
  methods: {
    getData() {
      axios
        .get("/api/user")
        .then((response) => {
          this.usr_orders = response.data;
        })
        .catch((error) => {
        });

      axios
        .get("/api/user/account")
        .then((response) => {
          response.data.forEach((channel) => {
            this.options_por_conta.push({
              value: channel.channel_account.name,
              text: channel.channel_account.name,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });

      axios
        .get("/api/orders/apps")
        .then((response) => {
          if (response.data.length) {
            this.apps = response.data;

            response.data.forEach((channel) => {
              if (channel.category == 2) return;
              this.availableChannels.push({
                value: channel.client_id,
                text: channel.name,
              });

              if (
                channel.category == 1 &&
                channel.client_id == "ff7d9cb152549fb4e05bb956909742a4"
              ) {
                this.checkFaturador = true;
              }
            });

            this.availableChannels = this.availableChannels.sort((a, b) => {
              if (b.text !== "Selecione um canal...")
                return a.text > b.text ? 1 : b.text > a.text ? -1 : 0;
              return;
            });

            this.availableChannelsAlert = this.availableChannels.length == 0; // --- Momento que deve mostrar a mensagem!
          }
        })
        .catch((error) => console.warn(error));
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Expedition.vue